import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { getHasOpenDialogs } from '~/store/duck/dialogs'

import AgentChatContent from './AgentChatContent'
import { useAgentChat } from './AgentChatContext'
import ChatWindowHeader from './ChatWindowHeader'

import styles from './AgentChatPanel.module.scss'

interface AgentChatPanelProps {
  closeChat: () => void
}

export default function AgentChatPanel({ closeChat }: AgentChatPanelProps) {
  const { t } = useTranslation('Agent')
  const { toggleChatMode } = useAgentChat()
  const isModalOpen = useSelector(getHasOpenDialogs)

  return (
    <div
      className={classNames(styles.agentChat, {
        [styles.modalOpen]: isModalOpen,
      })}
    >
      <ChatWindowHeader
        isFloating={false}
        title={t('Agent:AI_ASSISTANT')}
        onClose={closeChat}
        onToggleMode={toggleChatMode}
      />
      <AgentChatContent />
    </div>
  )
}
